// PREINTAKE L3 — CLEAN, STABLE, FINAL VERSION
// 100% fixed layout: header stays in place, no vertical jump
// Fully aligned with Kairos homepage proportions

import "./preintake.css";
import React, { useState } from "react";
import logo from "./assets/logo_kairos_black.png";

export default function PreIntake_L3({ onPass }) {
  // --- Backend verdict sender ---
  const sendVerdict = async (verdict) => {
    try {
      await fetch("https://kairos-backend-w90r.onrender.com/preintake", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ verdict }),
      });
    } catch (e) {
      console.warn("PreIntake error:", e);
    }
  };

  // --- Questions ---
  const questions = [
  {
    text: "What are you seeking here - specifically, not in general?",
    type: "text"
  },
  {
    text: "What part of yourself have you avoided looking at - in concrete terms?",
    type: "text"
  },
  {
    text: "When you face discomfort, do you tend to fight, flee, or shut down?",
    type: "buttons",
    options: ["Fight", "Flee", "Shut down"]
  },
  {
    text: "Describe one exact recent moment when you were clearly wrong.",
    type: "text"
  },
  {
    text: "Describe the exact physical sensation in your body right now (location + quality).",
    type: "text"
  },
  {
    text: "Are you willing to receive direct, unsweetened, high-intensity questions?",
    type: "buttons",
    options: ["Yes", "No"]
  }
];

  // --- State ---
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [hovered, setHovered] = useState(null);
  const [notReady, setNotReady] = useState(false);
  const [isCalibrating, setIsCalibrating] = useState(false);

  // --- Handle text input ---
  const handleTextSubmit = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;

    const updated = [...answers];
    updated[current] = trimmed;
    setAnswers(updated);
    setInputValue("");

    moveNext(updated);
  };

  // --- Handle button input ---
  const handleButtonSubmit = (val) => {
    const updated = [...answers];
    updated[current] = val;
    setAnswers(updated);

    moveNext(updated);
  };

  // --- MOVE NEXT WITH STRICT SAFE FILTER ---
  const moveNext = (arr) => {
  if (current < questions.length - 1) {
    setCurrent(current + 1);
    return;
  }

  const fails = (() => {
    const q1 = arr[0]?.trim().toLowerCase() || "";
    const q2 = arr[1]?.trim().toLowerCase() || "";
    const q3 = arr[2]?.trim().toLowerCase() || "";
    const q4 = arr[3]?.trim().toLowerCase() || "";
    const q5 = arr[4]?.trim().toLowerCase() || "";
    const q6 = arr[5]?.trim().toLowerCase() || "";

    // Avoidant patterns
    const avoidance = ["i don't know", "don't know", "idk", "maybe", "not sure", "i guess", "depends"];
    const emptyStates = ["nothing", "numb", "empty", "void", "neutral", "floating", "detached"];
    const shutdown = ["shut down", "freeze"];
    const skipIntents = ["why does this matter", "can we skip", "skip", "i don’t want", "i dont want"];

    // Under-minimal answers
    const tooShort = (t) => t.split(" ").length < 3;

    // Q1
    if (!q1 || tooShort(q1) || avoidance.some(a => q1.includes(a))) return true;

    // Q2
    if (!q2 || tooShort(q2) || avoidance.some(a => q2.includes(a))) return true;

    // Q3 — must be explicit fight
    if (q3 !== "fight") return true;

    // Q4 — must describe specific moment
    if (!q4 || tooShort(q4) || avoidance.some(a => q4.includes(a))) return true;

    // Q5 — must be a bodily description, not emptiness
    if (!q5 || emptyStates.some(a => q5.includes(a)) || shutdown.some(a => q5.includes(a))) return true;

    // Hard skips
    if (skipIntents.some(a => q1.includes(a) || q2.includes(a) || q4.includes(a) || q5.includes(a))) return true;

    // Q6 — explicit yes
    if (q6 !== "yes") return true;

    return false;
  })();

  // Render verdict
  if (fails) {
    sendVerdict("BLOCK");
    setNotReady(true);
  } else {
    sendVerdict("L3");
    setIsCalibrating(true);
    setTimeout(() => onPass(), 1800);
  }
};

  const q = questions[current];

  return (
    <div style={styles.container}>
     <div
  style={styles.logoWrapper}
  onClick={() => (window.location.href = "/")}
  onMouseEnter={(e) => (e.currentTarget.firstChild.style.opacity = "0.6")}
  onMouseLeave={(e) => (e.currentTarget.firstChild.style.opacity = "1")}
>
  <img
    src={logo}
    alt="Kairos Logo"
    style={{ ...styles.logo, cursor: "pointer", transition: "opacity 0.25s ease" }}
  />
</div>

      {/* Stable center wrapper */}
      <div style={styles.centerBox} className="preintake-center">
        <div style={styles.card}>
          <h1 style={styles.title} className="preintake-title">
             Level 3 - Advanced Vertical Cut
         </h1>

          <p style={styles.subtitle} className="preintake-subtitle">PreIntake Filter</p>

          {notReady && (
            <>
              <p style={styles.text}>
                It may not be the right moment yet. Take a breath and return when you feel aligned.
              </p>
              <button
                style={styles.button}
                onClick={() => {
                  setNotReady(false);
                  setCurrent(0);
                  setAnswers([]);
                }}
              >
                Try again later
              </button>
            </>
          )}

          {isCalibrating && (
            <>
              <p style={styles.calibratingText}>
                <em>Kairos is calibrating your readiness</em>
              </p>
              <div style={styles.dots}>
                <span style={{ ...styles.dot, animationDelay: "0s" }}>•</span>
                <span style={{ ...styles.dot, animationDelay: "0.2s" }}>•</span>
                <span style={{ ...styles.dot, animationDelay: "0.4s" }}>•</span>
              </div>
            </>
          )}

          {!notReady && !isCalibrating && (
            <>
              <p style={styles.question} className="preintake-question">{q.text}</p>

              {q.type === "text" && (
  <>
    <input
      style={styles.input}
      className="preintake-input"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder="Your answer..."
    />

    <button
      style={styles.button}
      onClick={handleTextSubmit}
    >
      Next
    </button>
  </>
)}

              {q.type === "buttons" && (
                <div style={styles.scale}>
                  {q.options.map((opt) => (
                    <button
                      key={opt}
                      onClick={() => handleButtonSubmit(opt)}
                      onMouseEnter={() => setHovered(opt)}
                      onMouseLeave={() => setHovered(null)}
                      style={{
                        ...styles.scaleButton,
                        ...(hovered === opt && {
                          transform: "scale(1.08)",
                          border: "2px solid #000",
                        }),
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              )}

              <div style={styles.progress}>
                {current + 1} / {questions.length}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "#fff",
    color: "#222",
    fontFamily: "Carlito, sans-serif",
    position: "relative",
    display: "flex",
    justifyContent: "center",
  },

  logoWrapper: {
    position: "fixed",
    top: 30,
    left: 30,
    zIndex: 1000,
  },

  logo: {
    height: 48,
  },

  centerBox: {
  width: "100%",
  maxWidth: 540,
  paddingTop: window.innerWidth < 600 ? "100px" : "290px",
  marginLeft: "auto",
  marginRight: "auto",
  paddingLeft: "0px",
  textAlign: "left",
},

  card: {
    width: "100%",
    maxWidth: 540,
  },

  title: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "-50px",
  },

  subtitle: {
    fontSize: "48px",
    marginBottom: "0px",
    color: "#222",
    fontWeight: 500,
  },

  question: {
    fontSize: "18px",
    minHeight: "72px", // NO MORE JUMP
    display: "flex",
    alignItems: "center",
    marginBottom: "0px",
  },

  text: {
    fontSize: "17px",
    marginBottom: "25px",
    lineHeight: 1.55,
  },

  input: {
  width: "100%",
  maxWidth: "100%",
  padding: "16px 20px",    // ← redus din 60px, adaptabil pe mobil
  borderRadius: "9999px",
  border: "1px solid #adadad",
  fontSize: "16px",
  marginBottom: "18px",
  outline: "none",
  boxSizing: "border-box", // ← previne overflow
},

  scale: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    marginBottom: "20px",
  },

  scaleButton: {
    padding: "10px 22px",
    borderRadius: "9999px",
    border: "1px solid #222",
    backgroundColor: "#fff",
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },

  button: {
    padding: "10px 20px",
    borderRadius: "9999px",
    border: "1px solid #ffffff",
    backgroundColor: "#222",
    color: "#fff",
    fontSize: 14,
    cursor: "pointer",
    width: "110px",
    fontFamily: "Carlito, sans-serif",
  },

  progress: {
    marginTop: "20px",
    fontSize: "14px",
    color: "#333",
  },

  calibratingText: {
    fontSize: "17px",
    fontStyle: "italic",
    marginBottom: "6px",
  },

  dots: {
    display: "flex",
    justifyContent: "center",
    fontSize: "12px",
  },

  dot: {
    color: "#222",
    opacity: 0.2,
    margin: "0 2px",
    animation: "pulseFade 1.2s infinite ease-in-out",
  },
};